import React from "react";
import Toast from "../../atoms/toast/Toast";
import ConfigManager from "../../components/system/config-rules/components/config-manager/ConfigManager";
import TokenManager from "../token-manager/TokenManager";

type PageRendererProps = {
  element: JSX.Element;
};

export default function onPageLoad() {
  return function PageRenderer({ element }: PageRendererProps) {
    return (
      <>
        <TokenManager />
        <ConfigManager />
        {element}
        <Toast />
      </>
    );
  };
}
